import ImageFrame from './ImageFrame'
import ImagePlaceholderFrame from './ImagePlaceholderFrame'
import SelectImage from './SelectImage'

export default class ImageSelectControl {
  constructor (element, args) {
    let div = document.createElement('div')
    let label = document.createElement('label')
    label.innerHTML = args.label
    let popup = null
    this.value = args.image
    this.property = document.createElement('div')
    this.property.className = 'contact'
    this.property.onclick = () => {
      if (args.readonly) {
        return
      }
      let popupElement = document.getElementById('popup')
      let viewportElement = document.getElementById('viewport')

      popup = new SelectImage(popupElement, {
        onok: (image) => {
          this.setValue(image)
          viewportElement.classList.remove('invisible')
          popupElement.classList.add('invisible')
          popupElement.innerHTML = ''

          if (this.onchange) {
            this.onchange()
          }
        },
        oncancel: () => {
          viewportElement.classList.remove('invisible')
          popupElement.classList.add('invisible')
          popupElement.innerHTML = ''
        },
        image: this.value
      })
      viewportElement.classList.add('invisible')
      popupElement.classList.remove('invisible')
    }

    this.image = undefined
    this.placeholder = undefined
    this.onchange = args.onchange

    if (this.value) {
      this.image = new ImageFrame(this.property, {
        image: this.value
      })
    } else {
      this.placeholder = new ImagePlaceholderFrame(this.property, {
        title: '?'
      })
    }

    div.appendChild(label)
    div.appendChild(this.property)

    let fragment = document.createDocumentFragment()
    fragment.appendChild(div)
    element.appendChild(fragment)
  }

  getValue () {
    return this.value
  }

  setValue (newImage) {
    this.value = newImage

    if (!newImage) {
      if (this.placeholder) {
        this.placeholder.setTitle('?')
      } else {
        this.placeholder = new ImagePlaceholderFrame(null, {title: '?'})
        this.property.insertBefore(this.placeholder.getElement(), this.property.childNodes[0])
      }

      if (this.image) {
        this.property.removeChild(this.image.getElement())
        this.image = undefined
      }

      return
    }

    if (this.image) {
      this.image.setImage(newImage)
    } else {
      this.image = new ImageFrame(null, {image: newImage})
      this.property.insertBefore(this.image.getElement(), this.property.childNodes[0])
    }

    if (this.placeholder) {
      this.property.removeChild(this.placeholder.getElement())
      this.placeholder = undefined
    }
  }

  setLabel (text) {
    this.label.innerHTML = text
  }
}



// WEBPACK FOOTER //
// ./js/lib/ui/ImageSelectControl.js